<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div v-if="vmodel !== null">
    <div v-if="isFriendConfig && !isDisabled && isCancelClick">
      <div class="grid line-text mt-5">
        <div class="grid col-12">
          <div class="col-12 lg:col-12">
            <label-shared
              :labelvalue="lmodel.setLandingPageTitle"
              :tooltipvalue="lmodel.setLandingPageTitleToolTip"
              labelclass="control-label"
              :isRequiredLabel="true"
            ></label-shared>
          </div>

          <div class="col-12 lg:col-6">
            <RadioButton
              :id="'dealLandingPageFixedNormal_'"
              v-model="vmodel1.setDealLandingPage"
              type="radio"
              :value="0"
              v-tooltip="lmodel.setDealLandingPageFixedToolTip"
            />
            <label
              class="ml-2 checkbox-font"
              :id="'lbldealLandingPageFixedDealFriend_'"
              :for="'dealLandingPageFixedFriend_'"
              @click="showfixed = !showfixed"
              v-tooltip="lmodel.setDealLandingPageFixedToolTip"
            >
              <span>{{ lmodel.setDealLandingPageFixed }}</span>
            </label>
          </div>

          <div class="col-12 lg:col-6 mt-2">
            <RadioButton
              :id="'dealLandingPageDynamic234_'"
              v-model="vmodel1.setDealLandingPage"
              type="radio"
              :value="1"
              v-tooltip="lmodel.setDealLandingPageDynamicToolTip"
            />
            <label
              class="ml-2 checkbox-font"
              :id="
                'lbldealLandingPageDynamic_' + vmodel.friendSetDealLandingPage
              "
              :for="'dealLandingPageDynamic_' + vmodel.friendSetDealLandingPage"
              @click="showdynamic = !showdynamic"
              v-tooltip="lmodel.setDealLandingPageDynamicToolTip"
            >
              <span>{{ lmodel.setDealLandingPageDynamic }}</span>
            </label>
          </div>
        </div>

        <div class="grid col-12 py-0">
          <div class="col-12 lg:col-12 py-0">
            <InputRequiredText
              v-model="vmodel1.setLandingPageUrl"
              :validation="valmodel.setLandingPageUrl"
              :IsLandingURL="true"
              id="LandingPageUrl"
              PropName="Landing Url"
              :placeholder="lmodel.setLandingPageUrlPlaceholder"
              v-show="vmodel1.setDealLandingPage == 0"
            ></InputRequiredText>
            <!-- <span v-if="modelstate.LandingPageUrl">{{
          modelstate.LandingPageUrl
        }}</span> -->
          </div>
        </div>

        <div class="grid col-12">
          <div class="col-12 lg:col-12">
            <label-shared
              :labelvalue="lmodel.setTargetFriendURLTitle"
              :tooltipvalue="lmodel.setTargetFriendURLTitleToolTip"
              labelclass="control-label"
              :isRequiredLabel="true"
            ></label-shared>
            <Textarea
              v-model="vmodel1.setTargetFriendURL"
              id="TargetFriendURL"
              :placeholder="lmodel.setTargetFriendURLPlaceholder"
              @blur="checkDomainFri()"
              class="mt-1"
            />
            <span
              v-if="errorMessageFri == false"
              style="color: red; font-size: 17px"
              >{{ staticData.frnddestination }}
            </span>
            <span
              v-if="
                catchErrorFri !== '' &&
                vmodel1.targetFriendURL !== null &&
                vmodel1.targetFriendURL !== ''
              "
              style="color: red; font-size: 17px"
              >{{ staticData.frnddestination }}</span
            >
          </div>
        </div>

        <!-- Conversion days -->
        <div class="grid col-12 py-0">
          <div class="col-12 lg:col-6 py-0">
            <label-shared
              :labelvalue="lmodel.friConversionDays"
              labelclass="control-label"
              :tooltipvalue="lmodel.friConversionDaysToolTip"
              tooltipvalueFor="friConversionDays-tooltip"
              :isRequiredLabel="false"
              PropName="Conversion no of days"
            ></label-shared>
            <InputRequiredNumber
              v-model="vmodel1.friConversionDays"
              id="friConversionDays"
              :validation="valmodel.friConversionDays"
              PropName="Conversion no of days"
              class="mt-1"
              :placeholder="lmodel.friConversionDaysPlaceholder"
              MinValue="0"
            ></InputRequiredNumber>
          </div>
          <div class="col-12 lg:col-6 py-0">
            <label-shared
              :labelvalue="lmodel.friReferralSessionBlockTime"
              labelclass="control-label"
              :tooltipvalue="lmodel.friReferralSessionBlockTimeToolTip"
              tooltipvalueFor="friReferralSessionBlockTime-tooltip"
              :isRequiredLabel="true"
            ></label-shared>
            <InputRequiredNumber
              v-model="vmodel1.friReferralSessionBlockTime"
              :validation="valmodel.friReferralSessionBlockTime"
              PropName="Referral Session Block Time"
              id="friReferralSessionBlockTime"
              :min="0"
              class="mt-1"
              :max="365"
            ></InputRequiredNumber>
          </div>
        </div>

        <div class="grid col-12 mt-2">
          <div class="grid col-12">
            <h3 class="ml-2">{{ lmodel.generalFriendSettings }}</h3>
          </div>
          <div class="col-12 lg:col-4">
            <Checkbox
              :binary="true"
              v-model="vmodel1.friendIsEnableRewardCode"
              id="isEnableRewardCode"
              type="checkbox"
            />

            <label
              for="isEnableRewardCode"
              class="ml-2 checkbox-font"
              id="friDisableFriendCode-tooltip"
              v-tooltip="lmodel.friDisableFriendCodeToolTip"
              >{{ lmodel.friDisableFriendCode }}
            </label>
          </div>

          <div class="col-12 lg:col-4">
            <Checkbox
              :binary="true"
              v-model="vmodel1.friAllowFriendExistingMember"
              id="allowFriendExistingMember"
              type="checkbox"
            />

            <label
              for="allowFriendExistingMember"
              class="ml-2 checkbox-font"
              id="friAllowExistingMember"
              v-tooltip="lmodel?.friAllowExistingMemberToolTip"
              >{{ lmodel?.friAllowExistingMember }}
            </label>
          </div>

          <div class="col-12 lg:col-4">
            <Checkbox
              :binary="true"
              id="friAllowSameReward"
              v-model="vmodel1.friAllowSameReward"
              type="checkbox"
              :value="true"
            />
            <label
              for="friAllowSameReward"
              class="ml-2 checkbox-font"
              id="friAllowSameReward-tooltip"
              v-tooltip="lmodel?.friAllowSameRewardToolTip"
            >
              {{ lmodel?.friAllowSameReward }}
            </label>
          </div>

          <div class="col-12 lg:col-4">
            <Checkbox
              :binary="true"
              v-model="vmodel1.friendInfoAfterCode"
              id="infoAfterCode"
              type="checkbox"
              @change="
                vmodel.friendInfoAfterCode == true
                  ? [
                      (vmodel1.friendHideOptinFriend = false),
                      (vmodel1.friendIsShowFriendCode = true),
                      (vmodel1.friCombinecodeinfo = false),
                    ]
                  : 1 == 1
              "
            />
            <label
              for="infoAfterCode"
              class="ml-2 checkbox-font"
              id="friendInfoAfterCode-tooltip"
              v-tooltip="lmodel?.friendInfoAfterCodeToolTip"
            >
              {{ lmodel?.friendInfoAfterCode }}
            </label>
          </div>

          <div class="col-12 lg:col-4">
            <Checkbox
              :binary="true"
              v-model="vmodel1.friendIsShowFriendCode"
              id="isEnableRewardCode"
              type="checkbox"
              :disabled="vmodel.friendRewardTime == '1'"
            />

            <label
              for="isEnableRewardCode"
              class="ml-2 checkbox-font"
              id="friDisableFriendCode-tooltip"
              v-tooltip="lmodel?.friShowCodeInPopupToolTip"
              >{{ lmodel?.friShowCodeInPopup }}
            </label>
          </div>

          <div class="col-12 lg:col-4">
            <Checkbox
              :binary="true"
              id="allow"
              v-model="vmodel1.friendAllowMinimizeOnLastStep"
              type="checkbox"
              :value="true"
            />
            <label
              for="allow"
              class="ml-2 checkbox-font"
              id="allow-tooltip"
              v-tooltip="lmodel?.friAllowMinimizeOnLastStepToolTip"
            >
              {{ lmodel?.friAllowMinimizeOnLastStep }}
            </label>
          </div>

          <div class="col-12 lg:col-4">
            <Checkbox
              :binary="true"
              v-model="vmodel1.friCombinecodeinfo"
              id="friCombinecodeinfo"
              type="checkbox"
              @change="
                vmodel.friCombinecodeinfo == true
                  ? [
                      (vmodel1.friendHideOptinFriend = false),
                      (vmodel1.friendInfoAfterCode = false),
                    ]
                  : 1 == 1
              "
            />
            <label
              for="friCombinecodeinfo"
              class="ml-2 checkbox-font"
              id="friendCombineCodeInfo-tooltip"
              v-tooltip="lmodel?.friendCombineCodeInfoToolTip"
            >
              {{ lmodel.friendCombineCodeInfo }}
            </label>
          </div>
        </div>

        <div class="grid col-12 mt-2">
          <div class="col-12 lg:col-12">
            <label-shared
              :labelvalue="lmodel?.friYourCodeWillShowHereText"
              :tooltipvalue="lmodel?.friYourCodeWillShowHereTextToolTip"
              tooltipvalueFor="friYourCodeWillShowHereText-tooltip"
              labelclass="control-label"
              :isRequiredLabel="false"
            ></label-shared>
            <InputText
              v-model="vmodel1.friYourCodeWillShowHereText"
              id="friYourCodeWillShowHereText"
              type="text"
              class="mt-2"
              :placeholder="lmodel?.friYourCodeWillShowHereTextPlaceholder"
              autocomplete="off"
            />
          </div>
        </div>

        <div class="grid col-12">
          <div class="col-12 lg:col-12">
            <h3>Open deal by</h3>
          </div>
        </div>

        <div class="grid col-12">
          <div class="col-12 lg:col-6 py-0">
            <label-shared
              :labelvalue="lmodel?.friOpenDealTagForExistingMember"
              :tooltipvalue="lmodel?.friOpenDealTagForExistingMemberToolTip"
              tooltipvalueFor="friOpenDealTagForExistingMember-tooltip"
              labelclass="control-label"
              :isRequiredLabel="false"
            ></label-shared>
            <InputText
              v-model="vmodel1.friOpenDealTagForExistingMember"
              class="form-control"
              autocomplete="nope"
              type="text"
              id="friOpenDealTagForExistingMember"
            />
          </div>

          <div class="col-12 lg:col-6 py-0">
            <label-shared
              :labelvalue="lmodel?.friOpenDealbytagbyIdentified"
              :tooltipvalue="lmodel?.friOpenDealbytagbyIdentifiedToolTip"
              tooltipvalueFor="friOpenDealbytagbyIdentifiedToolTip-tooltip"
              labelclass="control-label"
              :isRequiredLabel="false"
            ></label-shared>
            <InputText
              v-model="vmodel1.friOpenDealbytagbyIdentified"
              autocomplete="nope"
              type="text"
              id="friOpenDealbytagbyIdentified"
            />
          </div>

          <div class="col-12 lg:col-6 py-0">
            <label-shared
              :labelvalue="lmodel?.friDealtagafterfinish"
              :tooltipvalue="lmodel?.friDealtagafterfinishToolTip"
              tooltipvalueFor="friDealtagafterfinish-tooltip"
              labelclass="control-label"
              :isRequiredLabel="false"
            ></label-shared>
            <InputText
              id="FriDealtagafterfinish"
              v-model="vmodel1.friDealtagafterfinish"
              type="text"
              autocomplete="off"
              :placeholder="lmodel?.friDealtagafterfinishPlaceholder"
            />
          </div>

          <div class="col-12 lg:col-6 py-0">
            <label-shared
              :labelvalue="lmodel?.friRUAR"
              labelclass="control-label"
              :tooltipvalue="lmodel?.friRUARToolTip"
              tooltipvalueFor="ambRUAR-tooltip"
              :isRequiredLabel="false"
            ></label-shared>
            <InputRequiredText
              v-model="vmodel1.friRUAR"
              :validation="valmodel.friRUAR"
              :IsLandingURL="true"
              PropName="Redirect URL"
              id="friRUAR"
              type="text"
              :placeholder="lmodel?.friRUARPlaceholder"
              autocomplete="off"
            ></InputRequiredText>
          </div>

          <div
            class="col-12 lg:col-6"
            v-show="vmodel.friAllowFriendExistingMember == false"
          >
            <label-shared
              :labelvalue="lmodel.friAlreadyMemberHeader"
              :tooltipvalue="lmodel.friAlreadyMemberHeaderToolTip"
              tooltipvalueFor="friAlreadyMemberHeader-tooltip"
              labelclass="control-label"
              :isRequiredLabel="false"
            ></label-shared>
            <InputText
              v-model="vmodel1.friAlreadyMemberHeader"
              id="alreadyMemberHeader"
              type="text"
              autocomplete="off"
            />
          </div>
          <div
            class="col-12 lg:col-6"
            v-show="vmodel.friAllowFriendExistingMember == false"
          >
            <label-shared
              :labelvalue="lmodel.friAlreadyMemberText"
              :tooltipvalue="lmodel.friAlreadyMemberTextToolTip"
              tooltipvalueFor="friAlreadyMemberText-tooltip"
              labelclass="control-label"
              :isRequiredLabel="false"
            ></label-shared>
            <InputText
              v-model="vmodel1.friAlreadyMemberText"
              id="alreadyMemberText"
              type="text"
              autocomplete="off"
            />
          </div>
        </div>

        <div class="grid col-12">
          <div class="col-12 lg:col-12">
            <h3>Open deal by</h3>
          </div>
        </div>
        <div class="grid col-12">
          <div class="col-12 lg:col-6 py-0">
            <Checkbox
              :binary="true"
              v-model="vmodel1.friEnableFriendMails"
              id="friEnableFriendMails"
              type="checkbox"
              @change="
                vmodel.friEnableFriendMails == true
                  ? (vmodel1.friendHideOptinFriend = false)
                  : [
                      (vmodel1.friCombinecodeinfo = false),
                      vmodel.friendIsEnableRewardCode == true
                        ? (vmodel1.friendCampaignDealyDays = 0)
                        : (vmodel1.friendCampaignDealyDays =
                            vmodel.friendCampaignDealyDays),
                    ]
              "
            />
            <label
              for="EnableFriendMails"
              class="ml-2 checkbox-radio-font"
              id="friEnableFriendMails-tooltip"
              v-tooltip="lmodel?.friEnableFriendMailsToolTip"
            >
              {{ lmodel?.friEnableFriendMails }}
            </label>
          </div>
          <div class="col-12 lg:col-6 py-0">
            <Checkbox
              :binary="true"
              v-model="vmodel1.friEmailReminder"
              id="friEmailReminder"
              type="checkbox"
              @change="
                vmodel1.friEmailReminder == false
                  ? [
                      (vmodel1.friendRemindBeforeDays = 0),
                      (vmodel1.friendSecondRemindBeforeDays = 0),
                    ]
                  : [
                      (vmodel1.friendRemindBeforeDays = 14),
                      (vmodel1.friendSecondRemindBeforeDays = 2),
                    ]
              "
            />
            <label
              for="friEmailReminder"
              class="ml-2 checkbox-radio-font"
              id="friEmailReminder-tooltip"
              v-tooltip="lmodel?.friEmailReminderToolTip"
            >
              {{ lmodel?.friEmailReminder }}
            </label>
          </div>
        </div>
      </div>
      <div
        :class="
          !isDisabled
            ? 'header-edit-mode text-right button-container'
            : 'head-mode text-right button-container'
        "
      >
        <PrimeButton
          id="cancelbtn"
          @click="cancelBtn()"
          type="button"
          name="Cancel"
          value="cancel"
          label="Cancel"
          class="cancel-btnadd"
        />
        <PrimeButton
          label="Save"
          class="save-btn1 ml-2 mr-2"
          icon="save-icon"
          @click="saveReward()"
        ></PrimeButton>
      </div>
    </div>

    <!-- <div v-if="(isReferrals && isDisabled) || (isSave && !isReferrals)">
      <div class="grid line-text">
        <div class="col-12 lg:col-3">
          <label for="rewardType" class="control-labelextra">
            {{ staticData.rewards.rwdtype }}
          </label>
        </div>
        <div class="col-12 lg:col-7">
          <label for="rewardType1" class="control-labeladd">
            {{ staticData.rewards.voyadopromo }}
          </label>
        </div>
      </div>
      <div class="grid line-text">
        <div class="col-12 lg:col-3">
          <label for="Voyadopromotion" class="control-labelextra">
            {{ staticData.rewards.voyadopromo }}
          </label>
        </div>
        <div class="col-12 lg:col-7">
          <label for="Promotionid" class="control-labeladd">
            {{ staticData.rewards.voyadopromoid }}
          </label>
        </div>
      </div>
      <div class="grid line-text-2">
        <div class="col-12 lg:col-3">
          <label for="ambrwdtiming" class="control-labelextra">
            {{ staticData.rewards.ambrwdtiming }}
          </label>
        </div>
        <div class="col-12 lg:col-7">
          <label for="dateid" class="control-labeladd">
            {{ staticData.rewards.voyadodatedata }}
          </label>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import DataLayerService from "@/services/data-layer.service.js";
import staticData from "@/staticdata/static.json";
import moment from "moment";
import labelSharedVue from "@/components/shared/label-shared.vue";
export default {
  emits: ["openGetMeCodePopup", "exportUnusedCode", "call", "cancel"],

  components: {
    "label-shared": labelSharedVue,
  },

  props: {
    dealId: {
      type: String,
      default: null,
    },
    isCancelClick: {
      type: Boolean,
      default: false,
    },
    tabId: {
      type: Number,
      default: 0,
    },
    lmodel: {
      type: Object,
      default: null,
    },
    dmodel: {
      type: Object,
      default: null,
    },
    vmodel: {
      type: Object,
      default: null,
    },
    valmodel: {
      type: Object,
      default: null,
    },
    dealStatus: {
      type: Number,
      default: null,
    },
    isRedealText: {
      type: Boolean,
      default: false,
    },
    customerCampaignDealyDaysError: {
      type: String,
      default: null,
    },
    modelstate: {
      type: Object,
      default: null,
    },
    disableReferral: {
      type: Boolean,
      default: false,
    },
    friendCampaignDealyDaysError: {
      type: String,
      default: null,
    },
    isFriendConfig: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      staticData: staticData.friendconfig,
      isEnable: false,
      isEditMode: false,
      isSave: false,
      showEmbedWidget: false,
      errorMessageFri: true,
      todayDt: moment(),
      catchErrorFri: "",
      separatorExp: /,| /,
      invalidDates: null,
      codesresponse: "",
    };
  },
  computed: {
    vmodel1: {
      get() {
        return this.vmodel;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
    ambassadorRewardTimeOptionList() {
      let options = this.dmodel.ambassadorFriend.ambassadorRewardTimeList;
      if (this.vmodel1?.disablereferrals) {
        return options.filter((x) => x.value == 0 || x.value == -1);
      }
      return options;
    },
  },
  mounted() {
    document.addEventListener("click", this.handleOutsideClick);
  },
  created() {},

  beforeUnmount() {
    document.removeEventListener("click", this.handleOutsideClick);
  },
  methods: {
    popupCall() {
      this.ShowChangePopup = true;
    },
    cancelBtn() {
      this.$emit("cancel");
    },
    saveReward() {
      this.$emit("call");

      this.isSave = true;
    },
    EditData() {
      this.isEditMode = true;
    },

    checkDomainFri() {
      try {
        let domain = new URL(this.vmodel.setTargetFriendURL);
        domain = domain.hostname;
        DataLayerService.getById("/deal/validate", domain).then((result) => {
          this.errorMessageFri = result;
        });
      } catch (error) {
        this.catchErrorFri = error;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
input:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: none !important;
  border: #c0c0bc !important;
  outline: 2px solid #222222 !important;
  border-style: double !important;
}
.p-inputtext:enabled:focus {
  outline: 0 none !important;
  outline-offset: 0 !important;
  box-shadow: none !important;
  border: #c0c0bc !important;
  outline: 2px solid #222222 !important;
  border-style: double !important;
}

.p-button:enabled:hover {
  background-color: #2d6e6d;
  border-color: #2d6e6d;
  color: #fff;
}

input {
  color: #777 !important;
  font-size: 0.8rem;
  height: calc(1.5em + 0.75rem + 7px);
  width: 100%;
  box-shadow: none;
  border: 1px solid #c0c0bc;
  border-radius: 0.25rem;
  font-weight: 400;
  line-height: 1.5;
  padding: 0.375rem 0.75rem;
  font-family: "Voyado Text";
}
:deep(.p-inputtext) {
  color: #21211f !important;
  font-size: 16px;
  height: calc(1.5em + 0.75rem + 7px);
  width: 100%;
  box-shadow: none;
  border-radius: 0.25rem;
  font-weight: 400;
  line-height: 1.5;
  padding: 0.375rem 0.75rem;
  font-family: "Voyado Text";
  resize: none;
  // margin-bottom: 16px;
}
:deep(.p-inputtext:enabled:focus) {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: none;
}

:deep(.browse-button) {
  color: #ffffff;
  background: #2d6e6d !important;
  border-color: #2d6e6d !important;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  height: 37px;
  // opacity: 0.65;
  text-align: center;
  vertical-align: middle;
  border: 1px solid transparent;
  box-shadow: none;
  width: 100%;
  font-family: "Voyado Text";
}
.browse-button :hover {
  background: #2d6e6d !important;
  border-color: #2d6e6d !important;
}
.checkbox-radio-font {
  font-size: 14.22px;
}

:deep(.calBorder) {
  .p-button {
    border: 1px solid #c0c0bc !important;
    border-left: none !important;
  }
}
:deep(.calInput) {
  .p-inputtext {
    border-top-left-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0rem;
    border-bottom-right-radius: 0rem;
  }
}

:deep(.inputnumfocus) {
  .p-inputtext:enabled:focus {
    outline: 0 none;
    outline-offset: 0;
    box-shadow: none !important;
    border: #c0c0bc !important;
    outline: 2px solid #222222 !important;
    border-style: double !important;
  }
}

:deep(.input-wrapper input:focus) {
  outline: 1px solid black;
  border-radius: 4px;
  outline: none;
}

.p-inputgroup > .p-inputwrapper:last-child > .p-inputtext {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}
.p-inputgroup > input:first-child {
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 0px;
}

.fa {
  margin-left: auto !important;
}

.header-text {
  display: flex;
  align-items: center;
  height: auto;
  padding: 26px 40px 26px 40px;
  border-radius: 4px 4px 0px 0px;
}

.header-text span {
  display: block;
  margin-top: 5px;
}

.toggle-button {
  display: flex;
  align-items: center;
}

.toggle-button span {
  cursor: pointer;
  vertical-align: middle;
}

.col-4 {
  grid-column: span 4;
}
.col-8 {
  grid-column: span 8;
}

.border-box {
  border: 1px solid #c0c0bc;
  height: 40px;
  display: flex;
  border-radius: 4px;
  margin-left: 50px;
}

.voyadopromo-box {
  height: 40px !important;
  gap: 10px !important;
  border-radius: 4px 0px 0px 0px !important;
  border: 1px 0px 0px 0px !important;
}

.mobile-swap {
  height: 35px !important;
}
.line-text {
  align-items: center;
  padding: 0px 32px 0px 32px !important;
}
.line-text-2 {
  align-items: center;
  padding: 0px 32px 15px 32px;
}

.button-container {
  padding: 26px 40px 26px 40px;
}

:deep(.p-button:focus) {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: none !important;
}

.header-edit-mode {
  background-color: #f8f8f7 !important;
}
.head-mode {
  background-color: #fff !important;
}

:deep(.heading-text) {
  height: 19px;
  font-family: "Voyado Text";
  font-size: 16px;
  font-weight: 600;
  line-height: 19.2px;
  text-align: left;
  color: #21211f;
}
.container-text {
  font-family: "Voyado Text";
  font-size: 14.22px;
  font-weight: 400;
  line-height: 17.07px;
  text-align: left;
  color: #21211f;
}
.btn-change {
  background-color: #2d6e6d;
  border-color: #2d6e6d;
  color: #fff;
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.2rem;
  display: inline-block;
  font-weight: 400;
  text-align: center;
  vertical-align: middle;
}

.header-edit-mode {
  background-color: #f8f8f7 !important;
  // background: rgb(156, 119, 148) !important;
}

.head-mode {
  background-color: #fff !important;
}
.text-bold {
  font-weight: 600 !important;
}
:deep(.control-label) {
  font-size: 14.22px;
}

h5 {
  font-size: 15px;
}

h2 {
  padding: 0px;
  margin-bottom: 0px;
}

h3 {
  margin: 0px 0px;
}

.hed {
  height: 0px;
  font-weight: 500;
  font-size: 22.78px;
}

h4 {
  margin-top: 0px !important;
}

.con {
  margin-top: -20px;
}
// .icon-container {
//   display: flex;
//   flex-direction: column;
//   align-items: center;
// }
// .wizard-image {
//   height: 30px;
//   width: 40px;
//   border-top-left-radius: 4px;
//   border-top-right-radius: 4px;
// }
.checkbox-font {
  margin-left: 4px !important;
  font-family: "Voyado Text" !important;
  font-size: 14.22px !important;
  font-weight: 400 !important;
  line-height: 17.1px !important;
  text-align: left !important;
}
.radio-class {
  height: 20 px;
  padding: 4px 0px 0px 0px;
  border-radius: 10px 0px 0px 0px;
  border: 1px 0px 0px 0px;
  background: #ffffff;
}
</style>
